import React from 'react'
import Header from '../../subcategory/Header'
import SubCard from '../../../../../comon/SubCard'
import TadasanaImg from '../../../../../assets/images/yoga/Tadasana.png'
import GomukhasanaImg from '../../../../../assets/images/yoga/Gomukhasana.png'
import { useTranslation } from 'react-i18next'

const Posture = () => {
    const {t} = useTranslation();
    return (
        <>
        <Header headtitle={t("yoga.postureyoga")} />
        <SubCard fitImg={GomukhasanaImg} title={t("Gomukhasana.title")} context={false} workoutLink='/gomukhasana' />
        <SubCard fitImg={TadasanaImg} title={t("Tadasana.title")} context={false} workoutLink='/tadasana' />
        </>
      )
    }

export default Posture
